require('es6-promise').polyfill();
import axios from 'axios'
import forEach from 'lodash/forEach'
import { ErrorBag } from 'vee-validate'
import Vue from 'vue';
import store from './store'

let instance = axios.create({
    headers: {
        'X-CSRF-TOKEN': document.querySelector("meta[name='csrf-token']").getAttribute('content'),
        'X-Requested-With' : 'XMLHttpRequest',
    }
})

export function submitForm (url, formElem, opts) {
    return instance.post(url, new FormData(formElem), opts)
}

// Intercept response
instance.interceptors.response
    .use((response) => {
        // In case 200-299 returns "error"
        if (response.data.error || response.data.errors) {

            if(response.data.error && !response.config.suppressGlobalErrors && typeof swal !== 'undefined'){
                swal({
                    title: '',
                    text: response.data.error, 
                    type: "warning",
                    html: true
                });
            }

            return Promise.reject({
                error: response.data.error ? response.data.error : response.data.errors,
                response,
            })
        }

        if (response.config.url.indexOf('ping') === -1 || (response.config.url.indexOf('ping') !== -1 && response.config.params && response.config.params.force)) {
            store.dispatch('auth/recordLastActivity')
        }

        return response
    }, async (error) => {
        let errorBag = new ErrorBag()
        // Public payment status renders its own bounded, localized retry/auth feedback.
        if (error.config && error.config.suppressGlobalErrors) {
            return Promise.reject({error, errorBag, response: error.response})
        }
        if (error.response) {
            // Laravel validation error
            if (error.response.status === 422) {
                if (error.response.request.responseType === 'blob'
                 && error.response.data instanceof Blob
                 && error.response.data.type === 'application/json') {
                    error.response.data = JSON.parse(await error.response.data.text());
                }
                const membershipBillingErrors = error.response.data.membership_billing;
                if (Array.isArray(membershipBillingErrors) && membershipBillingErrors.length && typeof swal !== 'undefined') {
                    swal('', membershipBillingErrors[0], 'warning');
                }
                forEach(error.response.data, (value, key) => {
                    value.forEach(message => errorBag.add({ field: key, msg: message }))
                })
            } else if (error.response.status === 402 && typeof swal !== 'undefined') {
                swal({
                    title: trans('messages.subscribe_full_package'),
                    text: error.response.data,
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonText: trans('global.cancel'),
                    confirmButtonText: trans('settings.upgrade'),
                }, (confirmed) => {
                    if (confirmed) {
                        window.event_bus.$emit('showSubscriptionForm');
                    }
                });
            } else if (error.response.status === 401 && error.response.config.url.indexOf('ping') === -1) {
                window.event_bus.$emit('unauthenticated')
            } else if (error.response.status === 419) {
                window.event_bus.$emit('csrf_mismatch');
            } else if (error.response.status === 404) {
                //Dont show information about 404 errors
            } else if (error.response.data && typeof swal !== 'undefined') {
                const response = error.response.data;

                var error_text = trans('global.error');

                if(response.error){
                    error_text = response.error;
                }
                if(response.data){
                    error_text = response.data;
                }

                swal(trans('global.error_title'), error_text, "warning");
            }
        }

        return Promise.reject({
            error,
            errorBag,
            response: error.response
        })
    })


export let http = instance
